import store from '../store';
import { actions } from '../modules/modal/slice';

export default {
    showModal: (name, data) => store.dispatch(actions.open_modal({ name, data })),
    closeModal: (name) => store.dispatch(actions.close_modal(name)),
    closeAllModal: () => store.dispatch(actions.close_all_modal()),
};
